import urlSearchParamsPolyfill from 'url-search-params'

const isServiceWorker = typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope
const hasWindow = typeof window !== 'undefined'

export const urlSearchParams =
  !hasWindow || isServiceWorker ? urlSearchParamsPolyfill : (window.URLSearchParams || urlSearchParamsPolyfill)
